"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Hide(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M4.295 3l17 17-1.414 1.414-2.555-2.555a10.654 10.654 0 0 1-5.238 1.348c-7.572 0-10.787-7.294-10.92-7.606L1 12.207l.168-.395c.081-.189 1.335-2.965 4.002-5.109L2.881 4.414 4.295 3zM6.6 8.132c-1.87 1.438-2.986 3.283-3.402 4.08.723 1.407 3.494 5.995 8.891 5.995a8.653 8.653 0 0 0 3.748-.838l-1.725-1.725a3.921 3.921 0 0 1-2.023.563c-2.206 0-4-1.794-4-4 0-.74.208-1.43.562-2.024zm3.563 3.563a1.967 1.967 0 0 0-.074.512c0 1.103.897 2 2 2 .178 0 .347-.03.512-.074zm2.14-3.467l3.764 3.766a3.985 3.985 0 0 0-3.765-3.766zm-.214-4.02c-1.21 0-2.3.2-3.293.514l1.646 1.647a8.768 8.768 0 0 1 1.647-.162c5.396 0 8.168 4.588 8.89 5.996a13.405 13.405 0 0 1-1.947 2.756l1.426 1.425c1.68-1.818 2.485-3.63 2.551-3.783l.168-.394-.168-.395c-.133-.31-3.348-7.605-10.92-7.605z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Hide;
